var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.85 37Q27.8 37 26.4 35.6Q25 34.2 25 32.15Q25 30.1 26.4 28.7Q27.8 27.3 29.85 27.3Q31.9 27.3 33.3 28.7Q34.7 30.1 34.7 32.15Q34.7 34.2 33.3 35.6Q31.9 37 29.85 37ZM9 44Q7.8 44 6.9 43.1Q6 42.2 6 41V10Q6 8.8 6.9 7.9Q7.8 7 9 7H12.25V4H15.5V7H32.5V4H35.75V7H39Q40.2 7 41.1 7.9Q42 8.8 42 10V41Q42 42.2 41.1 43.1Q40.2 44 39 44ZM9 41H39Q39 41 39 41Q39 41 39 41V19.5H9V41Q9 41 9 41Q9 41 9 41ZM9 16.5H39V10Q39 10 39 10Q39 10 39 10H9Q9 10 9 10Q9 10 9 10ZM9 16.5V10Q9 10 9 10Q9 10 9 10Q9 10 9 10Q9 10 9 10V16.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.3edad6d658402a8cd170f90a93995aec.svg";
export { ForwardRef as ReactComponent };